const Equipment = {

    // FIELDS
    "name": "Name",
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "part_number": "Part Number",
    "new_part_number": "New Part Number",
    "old_part_number": "Old Part Number",
    "km_item_code": "KM Item Code",
    "make": "Make",
    "country_origin": "Country Origin",
    "status": "Status",
    "description": "Description",
    "document": "Document",
    "search": "Search",

    // PAGE HEADER
    "equipment": "Equipment",
    "equipment_assign": "Equipment Assign",

    // ERROR
    "error_name": "Enter Name",
    "error_department": "Select Department",
    "error_location": "Select Location",
    "error_component": "Select Component",
    "error_equipment": "Select Equipment",
    "error_new_part_number": "Enter New Part Number",
    "error_old_part_number": "Enter Old Part Number",
    "error_km_item_code": "Enter KM Item Code",
    "error_make": "Select Make",
    "error_country_origin": "Select Country Origin",
    "error_description": "Enter Description",
    "error_document": "Upload Document",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_department": "DEPARTMENT",
    "table_location": "LOCATION",
    "table_component": "COMPONENT",
    "table_equipment": "EQUIPMENT",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_make": "MAKE",
    "table_country_origin": "COUNTRY ORIGIN",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default Equipment;